import { render } from "./EmployeeCasesPanel.vue?vue&type=template&id=f51ad004&scoped=true"
import script from "./EmployeeCasesPanel.vue?vue&type=script&lang=js"
export * from "./EmployeeCasesPanel.vue?vue&type=script&lang=js"

import "./EmployeeCasesPanel.vue?vue&type=style&index=0&id=f51ad004&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51ad004"]])

export default __exports__